import React from "react";
import { Configure, InstantSearch } from "react-instantsearch-dom";
import { Box } from "@mui/material";

import SearchHits from "../hits";
import StateResults from "../search/state-results";
import typesenseClient from "../search/search-client";
import { CustomWindow } from "./../../custom.window";
import DisplayModeToggler from "../search/display-mode-toggler";

declare let window: CustomWindow;

type ContentSectionProps = {
  heading?: string;
  intro?: string;
  description?: string;
  facetFilters: string[];
  hitsPerPage?: number;
  displayMode?: string;
  sortBy?: string;
  children?: React.ReactNode;
  compact: Boolean;
  skeleton?: React.ReactNode;
  defaultDisplayMode?: "rows" | "grid" | "infinite-rows";
  showDisplayMode?: boolean;
  anchorName?: string | undefined;
};

const ContentSection = (props: ContentSectionProps): JSX.Element => {
  const {
    heading,
    intro,
    description,
    facetFilters,
    hitsPerPage = 5,
    defaultDisplayMode = "grid",
    sortBy,
    // children,
    compact = false,
    skeleton = <span />,
    showDisplayMode = true,
    anchorName = undefined,
  } = props;

  const indexName: string = typeof window.__indexName === "string" ? window.__indexName : "content_prod";

  const [displayMode, setDisplayMode] = React.useState(defaultDisplayMode);

  return (
    <>
      {anchorName && (
        <span
          id={anchorName}
          style={{
            display: "block",
            position: "relative",
            top: "-96px", // Compensate for header height
            visibility: "hidden",
          }}
        />
      )}
      <Box py={2} mt="1rem">
        <InstantSearch indexName={indexName} searchClient={typesenseClient({ sort_by: sortBy })}>
          {/* <Grid container>
            <Grid item xs={12} sm={8}> */}
          <h2>{heading}</h2>
          {/* </Grid>
            <Grid item xs={12} sm={4}></Grid>
          </Grid> */}

          {intro && <Box maxWidth="78ch">{intro}</Box>}

          {showDisplayMode && <DisplayModeToggler callback={setDisplayMode} />}

          {description && <Box className="content-section-description">{description}</Box>}
          <Configure hitsPerPage={hitsPerPage} analytics={false} enablePersonalization={false} facetFilters={facetFilters} sortBy={sortBy} />
          <Box>
            <StateResults fallback={skeleton}>
              <SearchHits mode={displayMode} />
            </StateResults>
          </Box>
        </InstantSearch>
      </Box>
    </>
  );
};

export default React.memo(ContentSection);
